/**
 * @description 已迁移到 OSS 的仓库大图路径集合。只命中这些路径，避免把未上传的小图误切到 OSS。
 */
export const STATIC_ASSET_OSS_PATHS = new Set([
  '/images/website/home/banner.png',
  '/animations/frame2/images/img_12.png',
  '/animations/frame3/images/img_17.png',
  '/images/credit/post_webank.png',
  '/images/credit/post_webank_mobile.png',
  '/images/website/solution/solution_banner_pc.png',
  '/images/store/coupon_products_banner_bg.png',
  '/animations/frame2/images/img_15.png',
  '/animations/frame2/images/img_13.png',
  '/animations/frame3/images/img_16.png',
  '/animations/frame1/images/img_4.png',
  '/images/credit/post_ningbo.png',
  '/animations/frame1/images/img_6.png',
  '/animations/frame2/images/img_14.png',
  '/images/credit/post_ningbo_mobile.png',
  '/animations/frame1/images/img_7.png',
  '/animations/frame3/images/img_15.png',
  '/animations/frame2/images/img_9.png',
  '/animations/frame3/images/img_10.png',
  '/animations/frame2/images/img_10.png',
  '/animations/frame2/images/img_11.png',
  '/images/service/banner-bg.jpg',
  '/images/website/solution/AI.svg',
  '/animations/frame3/images/img_8.png',
  '/animations/frame2/images/img_8.png',
  '/animations/frame3/images/img_11.png',
  '/images/service/img-case.png',
  '/images/store/activity_bg.png',
  '/images/website/solution/detail_bg.png',
  '/animations/frame4/images/img_3.png',
  '/images/website/solution/solution_bg.png',
  '/animations/frame3/images/img_9.png',
  '/images/service/img-solution.png',
  '/animations/frame4/images/img_4.png',
  '/animations/frame4/images/img_1.png',
  '/images/website/solution/solution_bg_m.png',
  '/images/website/join/hero-bg.webp',
  '/animations/frame1/images/img_11.png',
  '/animations/frame1/images/img_12.png',
  '/animations/frame2/images/img_7.png',
  '/animations/frame3/images/img_7.png',
  '/animations/frame4/images/img_2.png',
  '/animations/frame1/images/img_2.png',
  '/images/website/join/hero-bg-mobile.webp',
  '/images/gong_cheng_bao.png',
])

/**
 * Public assets hosted in the dedicated Tenda bucket at /tenda/public.
 * The certificate template is deliberately excluded because it is rendered into a canvas and the
 * public bucket does not currently grant the browser CORS access that canvas rendering requires.
 */
export const TENDA_PUBLIC_STATIC_ASSET_PATHS = new Set([
  '/images/agency/agency-query-banner-mobile.png',
  '/images/agency/agency-query-banner-text.png',
  '/images/website/home/cards/router-wifi7.png',
  '/images/website/home/cards/router-wifi6.png',
  '/images/website/home/cards/usb-adapter.png',
  '/images/website/home/cards/teg22-switch.png',
  '/images/store/home/featured-business-network.png',
  '/images/website/profile/introduction-second.png',
  '/images/website/home/cards/ceiling-ap.png',
  '/images/store/category-pk/home-network-pk-reference.png',
  '/images/store/home/store-home-banner-fallback.png',
  '/images/store/home/featured-security-monitor.png',
  '/images/website/home/cards/commercial-camera.png',
  '/images/website/profile/img-company.png',
  '/images/website/home/cards/mesh-extension.png',
  '/images/store/home/featured-home-network.png',
  '/images/website/home/cards/outdoor-bridge.png',
  '/images/website/home/cards/indoor-camera.png',
  '/images/website/solution/solution-home-hero.webp',
  '/images/website/profile/company-map.png',
  '/images/website/home/cards/commercial-nvr.png',
  '/images/website/profile/pr7x.jpg',
  '/images/website/profile/pr6x.jpg',
  '/images/website/customer_service.jpg',
  '/images/footer/shipinhao-qr.png',
  '/images/store/promotion/product-detail-bar-bg.png',
  '/images/store/account/channel-certification/id-card-front-example.jpg',
  '/images/store/account/channel-certification/id-card-back-example.png',
])

export const STATIC_ASSET_DISABLE_FORMAT_PREFIXES = ['/animations/']

/**
 * @description 规范化 public 静态资源路径。
 * @param {string} assetPath - public 目录下的资源路径。
 * @returns {string}
 */
export const normalizeStaticAssetPath = (assetPath) => {
  if (!assetPath) return ''
  if (/^(https?:|data:|blob:|\/\/)/i.test(assetPath)) return ''
  return assetPath.startsWith('/') ? assetPath : `/${assetPath}`
}

/**
 * @description 判断资源路径是否已纳入 OSS 静态资源清单。
 * @param {string} assetPath - public 目录下的资源路径。
 * @returns {boolean}
 */
export const shouldUseStaticAssetOrigin = (assetPath) => {
  const normalizedPath = normalizeStaticAssetPath(assetPath)
  return normalizedPath
    ? STATIC_ASSET_OSS_PATHS.has(normalizedPath) ||
        TENDA_PUBLIC_STATIC_ASSET_PATHS.has(normalizedPath)
    : false
}

export const shouldUseTendaPublicStaticAssetOrigin = (assetPath) => {
  const normalizedPath = normalizeStaticAssetPath(assetPath)
  return normalizedPath ? TENDA_PUBLIC_STATIC_ASSET_PATHS.has(normalizedPath) : false
}

export const shouldDisableStaticAssetOssFormat = (assetPath) => {
  const normalizedPath = normalizeStaticAssetPath(assetPath)
  return normalizedPath
    ? STATIC_ASSET_DISABLE_FORMAT_PREFIXES.some((prefix) => normalizedPath.startsWith(prefix))
    : false
}
